import config from '@/config'
import axios from 'axios'
import { authHeader } from '@/helpers'

const { API_URL } = config

export const userService = {
  login,
  register,
  logout,
  getAll,
  userInfo,
  registerUser,
  getOrders,
  updateProfile,
  forgotPassword,
  resetPassword
}
async function forgotPassword(email) {
  let url = `${API_URL}/api/forgotpw`
  let opts = {
    url,
    method: 'POST',
    data: { email }
  }
  let res = await axios(opts)
  return res.data
}

async function resetPassword(hash, password, confirmPassword) {
  let url = `${API_URL}/api/resetpassword`
  let data = {
    hash,
    password,
    confirmPassword
  }
  let opts = {
    url,
    method: 'POST',
    data: data
  }
  let res = await axios(opts)
  return res.data

}

async function updateProfile(updateData) {
  // {name,email,phone}
  let url = `${API_URL}/api/user/updateProfile`
  let opts = {
    url,
    method: 'POST',
    data: {
      updates: updateData
    },
    headers: authHeader()
  }
  let resp = await axios(opts)
  return resp.data
}
async function getOrders() {
  let url = `${config.API_URL}/api/user/orders`
  let opts = { url, headers: authHeader() }
  let resp = await axios(opts)
  return resp.data
}

function login(email, password) {
  let url = `${config.API_URL}/login`
  let data = {
    email: email,
    password
  }
  console.log('submitting login..', url, data.email)
  let opts = { url, data, method: 'POST' }
  return new Promise((resolve, reject) => {
    axios(opts) // or axios.post(url,data)
      .then(function (res) {
        let { data } = res
        let { token } = data
        // console.log(token)
        if (token) {
          localStorage.setItem('user', JSON.stringify(data))
        } else {
          reject(new Error('Login Failure'))
        }
        resolve(data)
      })
      .catch((err) => {
        // console.error(err)
        reject('Email or password is incorrect.')
        // reject(err)
      })
  })

}

function registerUser({ email, password, phone }) {
  let url = `${config.API_URL}/register`
  let data = {
    email: email,
    phone: phone,
    password: password
  }
  let opts = { url, data, method: 'POST' }
  console.log(`registering user account ${email}`)
  return new Promise((resolve, reject) => {
    axios(opts)
      .then((res) => {
        let { data } = res
        let { token, success } = data
        if (!success) return reject(new Error(data.error))
        if (token) {
          localStorage.setItem('user', JSON.stringify(data))
        } else {
          return reject(new Error('no token'))
        }
        resolve(data)
      })
  })
}

function register({ name, email, password, token }) {
  let url = `${config.API_URL}/register/ad`
  let data = {
    name: name,
    email: email,
    password,
    adtoken: token,
  }
  let opts = { url, data, method: 'POST' }
  console.log(`registering account with email ${email}`)
  return new Promise((resolve, reject) => {
    axios(opts)
      .then((res) => {
        let { data } = res
        let { token, success } = data
        if (!success) return reject(new Error(data.error))
        if (token) {
          localStorage.setItem('user', JSON.stringify(data))
        } else {
          return reject(new Error('no token'))
        }
        resolve(data)
      })
      .catch(err => reject(err))
  })
}


function logout() {
  localStorage.removeItem('user')
}


function userInfo() {
  let url = `${API_URL}/api/user/info`
  let opts = {
    url,
    headers: authHeader()
  }
  return new Promise((resolve, reject) => {
    // console.log('getting user info')
    axios(opts)
      .then((res) => {
        let { data } = res
        if (res.status == 401) {
          // logout and refresh
          logout()
          location.reload(true)
        }
        resolve(data)
      })
      .catch((err) => {
        if (err.response.status == 401) { // this cud be bad if api down but ya TODO
          console.error('invalid jwt token - 401 response! logging out..')
          logout()
          return location.reload(true)
        }
        reject(err)
      })
  })
}


function getAll() { // this is to retrive all users lol
  let url = `${config.API_URL}/users`
  let opts = {
    method: 'GET',
    headers: authHeader(),
    url: url
  }
  return axios(opts)
    .then(console.log)
}